// extracted by mini-css-extract-plugin
module.exports = {"page":"Preview_page__26kqs","body":"Preview_body__2aXb5","document":"Preview_document__KovvA","modal":"Preview_modal__1azpi"};